export default () => {
  return {
    /**
     * List of tags used by current clinic
     */
    clinicTags: {},

    /**
     * List of new tags that haven't been saved yet
     */
    unsavedClinicTags: [],

    /**
     * List of default Hi Rasmus tags
     */
    defaultTags: {},

    /**
     * Indicates whether the default tags has already been copied to the current clinicSettings tags collection
     */
    isDefaultTagsInitialized: false,
  };
};
